import React, { useEffect, useState } from "react"
import { formValueSelector } from "redux-form"
import { Col, Nav, NavLink, Row, TabContent, TabPane } from "reactstrap"
import "components/style.scss"
import { getBusinessUnits, getCategories } from "store/actions"
import { connect } from "react-redux"
import { FORM_NAMES } from "constants/index"
import PhonePreview from "./phonePreview"
import DetailsTab from "./detailsTab"
import LayoutTab from "./layoutTab"
import DesignTab from "./designTab"
import BottomNavigation from "components/BottomNavigation"

const SetUpTab = ({
  getBusinessUnits,
  selectedEvent,
  getCategories,
  handleNextTab,
  handleSave,
  handleCreate,
  experienceName,
  setSubTabBreadcrumb,
  tabIsActive,
}) => {
  useEffect(() => {
    getBusinessUnits()
    getCategories({ type: 1 })
  }, [])

  const TABS = {
    DETAILS: 1,
    LAYOUT: 2,
    DESIGN: 3,
  }

  const [activeTab, setActiveTab] = useState(TABS.DETAILS)

  useEffect(() => {
    if (tabIsActive) {
      setActiveTab(TABS.DETAILS)
      setSubTabBreadcrumb([
        {
          title: "Set Up",
          type: "tab",
          clickHandler: () => setActiveTab(TABS.DETAILS),
        },
        {
          title: "Details",
        },
      ])
    }
  }, [tabIsActive])

  useEffect(() => {
    setSubTabBreadcrumb([
      {
        title: "Set Up",
        type: "tab",
        clickHandler: () => setActiveTab(TABS.DETAILS),
      },
      {
        title:
          activeTab === 1 ? "Details" : activeTab === 2 ? "Layout" : "Design",
      },
    ])
  }, [activeTab])

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  return (
    <React.Fragment>
      <Row>
        <Col xl={8}>
          <Row className="mt-3">
            <Col xs="auto ms-5">
              <Nav pills className="flex-column">
                <NavLink
                  className={markIfIsActive(TABS.DETAILS)}
                  onClick={() => setActiveTab(TABS.DETAILS)}
                  style={
                    activeTab === TABS.DETAILS
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Details</span>}
                </NavLink>
                <NavLink
                  className={markIfIsActive(TABS.LAYOUT)}
                  onClick={() => setActiveTab(TABS.LAYOUT)}
                  disabled={!selectedEvent}
                  style={
                    activeTab === TABS.LAYOUT
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Layout</span>}
                </NavLink>
                <NavLink
                  className={markIfIsActive(TABS.DESIGN)}
                  onClick={() => setActiveTab(TABS.DESIGN)}
                  disabled={!selectedEvent}
                  style={
                    activeTab === TABS.DESIGN
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Design</span>}
                </NavLink>
              </Nav>
            </Col>
            <Col>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={TABS.DETAILS} style={{ animation: "none" }}>
                  <DetailsTab
                    tabIsActive={activeTab === TABS.DETAILS}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleSave={!selectedEvent ? handleCreate : handleSave}
                    handleNext={
                      !selectedEvent ? null : () => setActiveTab(TABS.LAYOUT)
                    }
                    saveButtonDisabled={!experienceName}
                  />
                </TabPane>
                <TabPane tabId={TABS.LAYOUT} style={{ animation: "none" }}>
                  <LayoutTab
                    tabIsActive={activeTab === TABS.LAYOUT}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.DETAILS)}
                    handleSave={handleSave}
                    handleNext={() => setActiveTab(TABS.DESIGN)}
                  />
                </TabPane>
                <TabPane tabId={TABS.DESIGN} style={{ animation: "none" }}>
                  <DesignTab
                    tabIsActive={activeTab === TABS.DESIGN}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.LAYOUT)}
                    handleSave={handleSave}
                    handleNext={handleNextTab}
                  />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <div
            style={{
              position: "sticky",
              top: "100px",
            }}
          >
            <PhonePreview />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.EXPERIENCE)

const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits || [],
  selectedEvent: state.experiences.selectedEvent,
  experienceName: selector(state, "setup.name"),
  categories: state.Categories.categories,
})

const mapDispatchToProps = dispatch => ({
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getCategories: values => dispatch(getCategories(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SetUpTab)
